import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';

export default function TeamMemberCard({
  profileImageUrl,
  fullName,
  jobTitle,
  facebookProfileUrl,
  instagramProfileUrl,
  twitterProfileUrl,
  linkedinProfileUrl,
}) {
  return (
    <div className="team_member_profile ">
      <div className="profile_image_container flex h-96 w-80">
        <img src={profileImageUrl} className="image_el object-contain flex-auto outline-0" alt="" />
      </div>
      <div className="member_name text-3xl text-black py-2 pt-4 text-bold" style={{ fontFamily: 'Fjalla One' }}>
        {fullName}
      </div>
      <div className="job_title  py-2 text-xl text-gray-500">{jobTitle}</div>
      <section className="social_info_list  py-2 ">
        {facebookProfileUrl && (
          <a href={facebookProfileUrl} className=" hover:text-[#ffb900] active:text-[#ffb900]">
            <FontAwesomeIcon size="xl" icon={faFacebookSquare} className="pr-5" />
          </a>
        )}
        {instagramProfileUrl && (
          <a href={instagramProfileUrl} className=" hover:text-[#ffb900] active:text-[#ffb900]">
            <FontAwesomeIcon size="xl" icon={faInstagram} className="pr-5" />
          </a>
        )}
        {twitterProfileUrl && (
          <a href={twitterProfileUrl} className=" hover:text-[#ffb900] active:text-[#ffb900]">
            <FontAwesomeIcon size="xl" icon={faTwitter} className="pr-5" />
          </a>
        )}
        {linkedinProfileUrl && (
          <a href={linkedinProfileUrl} target="_" className="text-[#1A1A1A] hover:text-[#ffb900] active:text-[#ffb900]">
            <FontAwesomeIcon size="xl" icon={faLinkedin} className="pr-5" />
          </a>
        )}
      </section>
    </div>
  );
}
